import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field-sw-update"
// Shows a non-intrusive "new version available" banner when the service worker
// has been updated. The user taps to reload — this avoids disrupting Taskers
// mid-task with an automatic reload.
export default class extends Controller {
  connect() {
    this._handler = () => this.element.classList.remove("hidden")
    document.addEventListener("sw:updated", this._handler)
  }

  disconnect() {
    document.removeEventListener("sw:updated", this._handler)
  }

  reload() {
    window.location.reload()
  }
}
